import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "iframe-wrapper" }
const _hoisted_2 = ["src"]

import { getGameUrl } from '@/api/game'
import StatusPopup from '@/components/common/statusPopup.vue'
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'gameView',
  setup(__props) {

const router = useRouter()
const route = useRoute();
const GameType = ref(route.query.game_type);
const gameMakerID = ref(route.query.game_maker);
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const iframeUrl = ref("")

const navToback = () => {
    router.go(-1)
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const gameUrl = () => {
    let params = {
        gameId: GameType.value,
        gameMakerId : gameMakerID.value
    }
    getGameUrl(params).then(res => {
        let resData = res.data
        iframeUrl.value = resData.game_url
        // let resData = res.data.data
        // iframeUrl.value = resData.game_url
    }).catch(err => {
        showError(err);
    })
}

onMounted(() => {
    gameUrl()
})

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "lobby",
        onClick: navToback
      }, [
        _createVNode(_component_van_icon, {
          name: "wap-home",
          color: "#fff",
          size: "22"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('game.lobby')), 1)
      ]),
      _createElementVNode("iframe", {
        src: iframeUrl.value,
        frameborder: "0"
      }, null, 8, _hoisted_2)
    ]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})